import TemporaryCache from "../../utils/gqlClientCacheMiddleware/temporaryCache";
import permanentCache from "../../utils/gqlClientCacheMiddleware/permanentCache";

const COUNTRIES_OP_NAME = "getCountries";
const COUNTRIES_CACHE_KEY = "getCountries";

export const globalCache =
	typeof window === "undefined"
		? new TemporaryCache(key => ([COUNTRIES_CACHE_KEY].includes(key) ? 60_000 : null))
		: permanentCache();

export const getCacheKey = ({ operationName }) =>
	// prettier-ignore
	operationName === COUNTRIES_OP_NAME ? COUNTRIES_CACHE_KEY :
	null;
